import {
  SignupAction,
  SignupActionType,
  SignupProps,
  SignupState,
  StateData
} from '../types'
import { restoreSignupSession, signupSession } from './signupSession'
import { SessionData } from '../lib/sessionData'

export const signupInitializer = (
  signupProps: SignupProps,
  sessionData: SessionData
) => (): SignupState => {
  const {
    analytics,
    authProvider,
    stack,
    properties,
    localization,
    userSession,
    sessionInterface,
    onboarding,
    serviceRouting,
    tenantHandlerInterface,
    app
  } = signupProps
  const isLoggedIn =
    sessionInterface.isLoggedIn() &&
    (tenantHandlerInterface === undefined ||
      tenantHandlerInterface.getCurrentContext() === 'tenant')
  return {
    analytics,
    authProvider,
    stack,
    properties,
    localization,
    isLoggedIn,
    userSession,
    sessionInterface,
    onboarding,
    serviceRouting,
    app,
    sessionData,
    signupSession: restoreSignupSession({
      isLoggedIn,
      signupProps,
      sessionData
    }),
    partialSubscription: {},
    subscription: {},
    shippingAddress: {},
    benefits: {},
    billingInfo: {},
    billingAddress: {},
    activeUser: {},
    printerDetails: {},
    userAccount: {},
    plans: {},
    abTestPlans: {},
    printers: {},
    settings: {},
    paths: {},
    preenrollment: {},
    deeplinkInfo: {},
    validations: {},
    printerOffer: {},
    banner: {},
    comfeSettings: {},
    taxpayerDetails: {}
  }
}

export const signupReducer = (
  state: SignupState,
  action: SignupAction
): SignupState => ({
  ...state,
  signupSession: signupSession(state, action),
  ...(action.type === SignupActionType.SET_STATE_DATA &&
  action.stateKey &&
  action.stateData &&
  state[action.stateKey]
    ? {
        [action.stateKey]: {
          ...state[action.stateKey],
          ...(action.stateData as StateData<unknown>)
        }
      }
    : {})
})
